/* avoiding the modifyStart to skip the redirect by default which is returning from gbo
and making it to stay on current page by passing redirect: false  */
import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';

export const skipModifyReservationStartRedirect =
  ({ redirect = true }) =>
  (dispatch) =>
    dispatch(
      gmiRequest({
        loadingOverlay: true,
        redirect,
        action: actions.request({
          service: services.gma.reservations.modifyStart,
        }),
      })
    );
